export let content = {
    English: {
      vaa:"Visa Assistance Abroad",
      vaadesc:"We serve the processing of visa applications abroad through the embassies of foreign countries in Indonesia.\nWe will help and provide free consultation at the office, for all visa applications to any country with an embassy in Indonesia.\nFor more than 20 years we have taken care of and helped submission of visa applications for the following countries.",
      vaasub:"Where do you want to go?",
      
      vab:"Visa Assistance in Bali",
      vabdesc:"We also offer visa assistance services in Bali, Indonesia. Our services range from helping you apply for a visa to providing the necessary documents for your application. We also assist with any enquiries around the process of obtaining a visa.",
      
      wedding:"Wedding Ceremony Organizer",
      weddingsub:"For Bali Only.",
      weddingsub2:"See Our Gallery",
      weddingdesc:"A Wedding is a very important event in Indonesia, especially in Bali. Getting married in Bali for Indonesian and Expat couples.\n\nTo get legally married in Bali, please kindly Contact Us. We will guide you from A to Z until you have a successful outcome. To be legally married in Indonesia requires a religious ceremony.\nOur Company can organize religious ceremony as follows :\n- As Moslem\n- As Christians\n- As Hindu\n- As Buddhist",
      weddingbtn:"Our Gallery",

      translate:"Translation Documents",
      translatedesc:"BCS will also provide the services of Translation any documents into any languages with a certified translator Sworn in Indonesia.",
      suchas:"Such as;",
      translatedesc2:"Provided by Sworn Translation Services in Indonesia for Bahasa Indonesia, English, Chinese, Japanese, Korean, German, Arabic, Thai, Vietnamese, Russian, Spanish, French, Dutch, Italian, etc.",
      contactus:"Please feel free to contact us anytime.",
      
      travel:"Travel Insurance",
      travelsub:"Issuing CHUBB Travel insurance only.",
      traveldesc:"Learn more about our product and get some travel tips while you are preparing for your next vacation.",
      traveldesc2:"Click for further information :",
      wa:"Lets Talk",
      ck:"Click Here",
      traveldesc3:"To reserve and book your travel insurance online, kindly please contact us",
      
      email:"Request Form",
      others:"Other Services",
      otherssub:"We provide document management",
    },  
    Indonesia:{
      vaa:"Visa Liburan, Visa Bisnis Keluar Negeri",
      vaadesc:"Kami melayani pengurusan visa aplikasi keluar negeri melalui kedutaan - kedutaan Negara Asing di Indonesia.\nKami akan membantu dan memberikan konsultasi gratis di kantor, untuk semua permohonan visa aplikasi ke Negara manapun yang ada kedutaannya di Indonesia.\nLebih dari 20 tahun kami mengurusi dan membantu pengajuan visa aplikasi untuk negara negara berikut ini.",
      vaasub:"Mau kemana?",
      
      vab:"Visa di Indonesia / Bali",
      vabdesc:"Kami juga mengurusi dan melayani pengurusan semua jenis visa dan dokumen bagi Expatriat/Warga Negara Asing / Turis yang datang dan tingat di Indonesia.\nLebih dari 15 tahun kami telah berpengalaman mengurusi jasa pengurusan kelengkapan dokumen melalui kantor Imigrasi dan kantor Pemerintahan yang terkait lainnya. Seperti:\n",
      
      wedding:"Upacara Pernikahan",
      weddingsub:"Khusus untuk Acara Nikah Bali",
      weddingdesc:"Pernikahan atau perkawinan adalah hal yang sangat penting dan Sakral (suci), Pernikahan campur atau tidak campur bisa dilaksanakan proses pernikahan di Bali, bisa dilaksanakan Pernikahan di tempat Ibadah atau dilaksanakan di Hotel/Villa atau tempat yang bisa ditentukan oleh pengantin/pasangan calon Pernikahan.\n\nKantor kami akan membantu dan memperlancar proses administrasi perkawinan yang resmi dan sah baik menurut Agama maupun sesuai Undang-undang / hukum Negara.\nKami, BCS akan membantu proses pernikahan sebagai berikut:\n- Agama Islam\n- Agama Kristen Katolik / Protestant \n- Agama Hindu\n- Agama Budha\n- Agama Konghucu",
      weddingsub2:"Lihat Galeri Kami",
      weddingbtn:"Our Gallery",
      
      translate:"Terjemahkan Dokumen",
      translatedesc:"BCS juga akan menyediakan jasa Penerjemahan dokumen apapun ke dalam bahasa apapun dengan penerjemah tersumpah bersertifikat di Indonesia.",
      suchas:"Seperti;",
      translatedesc2:"Disediakan oleh Layanan Terjemahan Tersumpah di Indonesia untuk Bahasa Indonesia, Inggris, Mandarin, Jepang, Korea, Jerman, Arab, Thailand, Vietnam, Rusia, Spanyol, Prancis, Belanda, Italia, dll.",
      contactus:"Jangan ragu untuk menghubungi kami kapan saja.",
      
      travel:"Asuransi Perjalanan",
      travelsub:"Menerbitkan asuransi Perjalanan CHUBB saja.",
      traveldesc:"Pelajari lebih lanjut tentang produk kami dan dapatkan beberapa tips perjalanan saat Anda mempersiapkan liburan berikutnya.",
      traveldesc2:"Klik untuk informasi lebih lanjut :",
      wa:"Hubungi Kami",
      ck:"Klik Disini",
      traveldesc3:"Untuk memesan dan memesan asuransi perjalanan Anda secara online, silakan hubungi kami",
      
      email:"Request Form",
      others:"Layanan Lainnya",
      otherssub:"Kami melayani pengurusan dokumen",
    }
  };